export const controlTypes = {
  host: { title: 'model.audioLoader.settings.controlledByHost' },
  user: { title: 'model.audioLoader.settings.controlledByUser' },
} as const;

export type ControlType = keyof typeof controlTypes;
